import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../shared/services/common.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  public error;

  constructor(private activatedRoute: ActivatedRoute, private commonService: CommonService) { }

  ngOnInit() {
    this.commonService.setLoadingFalse();

    if (this.activatedRoute.snapshot.data.error) {
      this.error = this.activatedRoute.snapshot.data.error;
    } else if (this.activatedRoute.snapshot.queryParams.error) {
      this.error = this.activatedRoute.snapshot.queryParams.error;
    } else {
      this.error = '404';
    }
  }
}
